import { conversationStorageKey } from "../conversation/snapshot";

/** New test 只回收本测试的浏览器快照。 */
export function clearPlaygroundState(shopDomain: string, uid: string): void {
  if (!uid.startsWith("test:")) return;
  try {
    sessionStorage.removeItem(conversationStorageKey(shopDomain, uid));
  } catch {
    /* 存储禁用时仍由 BFF 永久撤销旧访客。 */
  }
}
